import React from "react";
import { useIntl } from "react-intl";
import { BannerType, isBannerEnabled } from "../../commons/banner";
import GetDomainButton from "./GetDomainButton";
import AiroBuilderAd from "./AiroBuilderAd";
import { useLanderConfig } from "../../commons/ConfigContext";
import { LanderConfig } from "../../types/LanderConfig";
import { useIsMobile } from "../../commons/useIsMobile";
import { useAiroBannerExperiment } from "../../experimentation/useAiroBannerExperiment";
import classes from "./ParkwebGetDomain.module.scss";

// refactor: this should return a string like expiredDbsText, dbsText, auctionText, backorderText
export function getParkWebBannerText(landerConfig) {
  const bannerType = ((landerConfig.lander || {}).banner || {}).type;
  const expired = (landerConfig.domain || {}).expired;

  switch (bannerType) {
    case BannerType.DBS:
      return expired ? "expiredDbsText" : "dbsText";
    case BannerType.AUCTION:
      return expired ? "expiredAuctionText" : "auctionText";
    case BannerType.BACKORDER:
      return expired ? "expiredBackorderText" : "backorderText";
    default:
      return "";
  }
}

type DomainInfoProps = {
  landerConfig: LanderConfig;
};

function DomainInfo({ landerConfig }: DomainInfoProps) {
  const intl = useIntl();
  const messageId = getParkWebBannerText(landerConfig);
  const isMobile = useIsMobile();

  if (!messageId) return null;

  const text = intl.formatMessage(
    { id: messageId },
    { domain: landerConfig.domain.rootDomainDisplayText }
  );

  if (isMobile) {
    return <span className={ classes.getDomainTextInfo }>{text}</span>;
  }
  return <div className={ classes.getDomainTextInfo }>{text}</div>;
}

function Domain({ domain }: { domain: string }) {
  const isMobile = useIsMobile();
  if (!domain) return null;
  if (isMobile) {
    return <span className={ classes.getDomainTextDomain }>{domain} </span>;
  }
  return <div className={ classes.getDomainTextDomain }>{domain}</div>;
}

export default function ParkwebGetDomain() {
  const { landerConfig } = useLanderConfig();
  const domain = landerConfig.domain?.rootDomainDisplayText;
  const bannerType = landerConfig.lander?.banner?.type;
  const { showAiroAd } = useAiroBannerExperiment();

  // BACKORDER messages already include {domain} in their text, so we skip
  // rendering Domain separately to avoid showing the domain twice
  const isBackorderBanner = bannerType === BannerType.BACKORDER;

  if (!isBannerEnabled(landerConfig)) {
    return null;
  }

  return (
    <div data-testid="parkwebGetDomain" className={ classes.getDomainCard }>
      <div className={ classes.getDomainTextContainer }>
        {!isBackorderBanner && <Domain domain={ domain } />}
        <DomainInfo landerConfig={ landerConfig } />
      </div>
      <GetDomainButton
        landerConfig={ landerConfig }
        className={ classes.getDomainCta }
      />
      {showAiroAd && <AiroBuilderAd />}
    </div>
  );
}
